import HeaderStyles from "../../components/Header/HeaderStyles";

const PolicyDetailsStyles = {
  policyDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    minHeight: "92vh",
    padding: "30px",
  },
  link: {
    display: "flex",
    alignItems: "center",
    color: "#1D252B",
    fontFamily: "Noto Sans",
    fontSize: "18px",
    fontWeight: 400,
    cursor: "pointer",
    "@media (max-width: 599px)": {
      fontSize: "14px",
    },
    "@media (min-width: 600px) and (max-width: 1024px)": {
      fontSize: "16px",
    },
    "@media (min-width: 1024px) and (max-width: 1920px)": {
      fontSize: "18px",
    },
  },
  paperPropsStyles: {
    overflow: "unset",
    width: "50%",
    "@media (max-width:768px)": {
      width: "100%",
    },
  },
  payNowHeadingStyle: {
    fontFamily: "Playfair Display",
    fontSize: "20px",
    fontWeight: "400",
    lineHeight: "22px",
    textAlign: "left",
  },
  headerStyles: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #D8D8D8",
    width: "100%",
    padding: "20px",
  },
  paymentCardStyle: {
    display: "flex",
    alignItems: "center",
    height: "100%",
  },
  button: {
    padding: "9px 24px",
    boxShadow: "none",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
      color: "var(--support-white)",
    },
  },
};

export default PolicyDetailsStyles;
